export const tvFeatures = [
  {
    id: "support",
    icon: "ri-book-open-line",
    title: "以名著改编剧为载体的支线",
    desc:
      "在《水浒传》一类的长篇改编剧中，潘金莲并非唯一主角，而是贯穿若干集的重要支线；剧集容量让她与家人、邻里及市井人物的关系得以完整铺开。",
  },
  {
    id: "remake",
    icon: "ri-refresh-line",
    title: "重拍版本带来的差异",
    desc:
      "不同年代的重拍会对人物造型、情感动机与镜头语言重新处理。对照同一段落的不同版本，能清楚看到审美与表达方式的变化。",
  },
  {
    id: "capacity",
    icon: "ri-time-line",
    title: "长篇容量带来的完整感",
    desc:
      "相比一部电影，剧集有更多篇幅交代前因后果与配角走向，人物更立体，剧情转折也更从容，适合希望系统了解整体故事的观众。",
  },
  {
    id: "unit",
    icon: "ri-file-list-3-line",
    title: "单元剧与情景化处理",
    desc:
      "也有剧集把相关故事处理为独立单元，单集自成起落，围绕家庭与市井关系展开，观看门槛更低，便于按需选取。",
  },
];